interface AdminSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/** Consistent search box used across admin tables. */
export default function AdminSearchInput({ value, onChange, placeholder = "Search…" }: AdminSearchInputProps) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
        <i className="ri-search-line text-sm" />
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 w-full rounded-lg border border-background-300 bg-background-100 pl-8 pr-3 text-xs text-foreground-800 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-1 focus:ring-primary-100 sm:w-64"
      />
    </div>
  );
}